/* eslint-disable @next/next/no-before-interactive-script-outside-document */
import Script from 'next/script'

interface GoogleProps {
  enabled: boolean
  id?: string
}

export const GoogleGtmNoScript = ({
  enabled,
  id = `GTM-546N2JV`,
}: GoogleProps) => (
  <>
    {enabled && (
      <noscript
        id="google-gtm-noscript"
        dangerouslySetInnerHTML={{
          __html: `<iframe
            src="https://www.googletagmanager.com/ns.html?id=${id}"
            height="0"
            width="0"
            style="display:none;visibility:hidden"
          ></iframe>`,
        }}
      />
    )}
  </>
)

export const GoogleGtm = ({ enabled, id = `GTM-546N2JV` }: GoogleProps) => (
  <>
    {enabled && (
      <Script
        id="google-gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(function (w, d, s, l, i) {
              w[l] = w[l] || []; w[l].push({
                'gtm.start':
                  new Date().getTime(), event: 'gtm.js'
              }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                  'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
              })(window, document, 'script', 'dataLayer', '${id}');`,
        }}
        defer
      />
    )}
  </>
)

export const GoogleOptimize = (props: GoogleProps) => (
  <>
    {props.enabled && (
      <Script
        id="google-optimize"
        strategy="afterInteractive"
        type="text/javascript"
        src="https://www.googleoptimize.com/optimize.js?id=OPT-KVHTFSW"
        defer
      />
    )}
  </>
)
